import { DefaultVideoConstraints } from '../Settings';
export function getUserMedia(options) {
    const constraints = {
        video: DefaultVideoConstraints,
        audio: options.audio,
    };
    if (typeof options.video === 'object') {
        constraints.video = { ...DefaultVideoConstraints, ...options.video };
    }
    else if (options.video === false) {
        constraints.video = false;
    }
    return navigator.mediaDevices.getUserMedia(constraints);
}
